import { Link } from "react-router-dom";
import { PHONE_DISPLAY, PHONE_TEL } from "@/constants";

const COPY = {
  privacy: {
    title: "Privacy",
    body: (
      <>
        <h2>What we collect</h2>
        <p>
          If you fill in the callback form, we collect your name, business name, phone number, and type of business.
          That's it. We use it to call you back, nothing else.
        </p>
        <h2>What we don't do</h2>
        <p>
          We don't sell your information, share it with advertisers, or add you to a newsletter. There are no tracking
          cookies on this page set by us.
        </p>
        <h2>Calls to the demo line</h2>
        <p>
          Demo calls may be recorded so we can keep improving the agent. Don't share anything sensitive on a demo call.
        </p>
        <h2>Questions</h2>
        <p>
          Email <a href="mailto:hello@getfrontdeskagent.com">hello@getfrontdeskagent.com</a> or call{" "}
          <a href={PHONE_TEL}>{PHONE_DISPLAY}</a>.
        </p>
      </>
    ),
  },
  terms: {
    title: "Terms",
    body: (
      <>
        <h2>The service</h2>
        <p>
          Get Front Desk provides an AI voice agent that answers calls your business can't get to. Setup is $497, then
          $597 per month. No contract. Cancel anytime by letting us know.
        </p>
        <h2>The guarantee</h2>
        <p>
          If the agent doesn't capture at least 10 money-making conversations in your first 30 days, we refund your
          setup and your second month is free. A money-making conversation means a real person, describing a service
          need they have, who leaves a name and number.
        </p>
        <h2>What the agent doesn't do</h2>
        <p>
          The agent doesn't quote prices, take payments, or make promises on your behalf. You decide what it's allowed
          to answer.
        </p>
        <h2>Questions</h2>
        <p>
          Email <a href="mailto:hello@getfrontdeskagent.com">hello@getfrontdeskagent.com</a> or call{" "}
          <a href={PHONE_TEL}>{PHONE_DISPLAY}</a>.
        </p>
      </>
    ),
  },
};

export default function Legal({ kind }) {
  const page = COPY[kind] || COPY.privacy;
  return (
    <>
      <header className="site-header">
        <div className="container-x flex items-center justify-between" style={{ minHeight: 68 }}>
          <Link to="/" className="wordmark" data-testid="legal-wordmark">
            Get Front Desk
          </Link>
          <Link to="/" className="btn btn-primary" style={{ minHeight: 44 }} data-testid="legal-back-btn">
            Back to the site
          </Link>
        </div>
      </header>
      <main className="section-light">
        <div className="container-x">
          <h1 className="section-h2" data-testid="legal-title">
            {page.title}
          </h1>
          <div className="legal-body" data-testid="legal-body">
            {page.body}
          </div>
        </div>
      </main>
    </>
  );
}
